import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import data from 'src/assets/json/states.json';
import { CurrencyPipe } from '@angular/common';
import moment from 'moment';
import { QBOEnvironment } from 'src/environments/environment';
import { BrooklynInvestmentStatus, ResponseStatus, ValidationMessage } from '../../enum';

@Component({
  selector: 'app-add-update-investments',
  templateUrl: './add-update-investments.component.html',
  styleUrls: ['./add-update-investments.component.scss'],

  standalone: false,
})
export class AddUpdateInvestmentsComponent implements OnInit {
  isVisibleInvestmentModal = true;
  isVisibleInvestmentDetailsModal = true;
  isLoadingOne = false;
  isLoadingSaveInvestment = false;
  loadingNewCustomer = false;
  isConfirmUnderReviewVisible = false;
  feeValueCal: any;
  validationMessage = ValidationMessage;
  radioValue = 'A';
  listOfTerms: any[] = [];
  @Output() hideInvestmentDrawer = new EventEmitter();
  @Input() selectedData: any;
  @Input() isFutureInvestment: boolean = false;
  listOfStates: any = data.States;
  isLoadingPartner: any;
  isLoadingReps: boolean = true
  listOfCategory: any;
  isLoadingSubmittingInvestment: any;
  yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  nineMonths = new Date(new Date().setMonth(new Date().getMonth() + 9));
  disabledScheduleDate = (current: Date): boolean =>
    // Can not select days before today and today
    current <= this.yesterday ||
    current >= this.nineMonths ||
    (current.getDate() == this.nineMonths.getDate() &&
      current.getMonth() == this.nineMonths.getMonth());
  getInvestmentDetail: any;
  currentInvoiceAmount: any = 0;
  currentQuickbooksAmount: any = 0
  amountNumber: any;
  currentInvoiceProcessFee: any = 0;
  currentQuickbooksInvoiceProcessFee: any = 0
  paymentArray: any;
  netAmount: any;
  partnerId: any = '';
  investmentCustomerDetail: any;
  investmentquickBookDetail: any;
  investmentquickBookDetailId: any = '';
  isloadingApproveInvest: any = false;
  isloadingCancelInvest: any = false;
  isloadingUnderReviewInvest: any = false;
  isloadingSaveInvest: any = false;
  investmentCustomerDetailId: any;
  getAllCustomer: any;
  isLoadingSites: any;
  getAllSiteSelectedCustomer: any;
  getSiteDetails: any;
  partnerInvestmentDetail: any;
  getAllSuppliers: any;
  listOfUsersSites: any;
  customerDetails: any;
  siteIdByPartner: any = '';
  isInvestmentSkeleton: any = false;
  LineStreetAddress: any = false;
  isLoadingPrograms: any = false;
  investorDetails: any;
  listOfProductService: any;
  listOfTransactionClass: any;
  isExistingParentCompany = true;
  allInvestorFromQB: any;
  listOfYears: any;
  listOfProgramPeriods: any = [];
  qboURL = QBOEnvironment.URL;
  nonalcResult: any;
  deleteConfirmVisible: boolean = false;
  isInvalidAmount: boolean = false;
  isTransactionProcessing = false;
  siteId: any;
  @ViewChild('zipcode') zipcode: any;
  @ViewChild('desc') desc: any;
  @ViewChild('partnerDD') partnerDD: any;
  @ViewChild('company') company: any;
  @ViewChild('city') city: any;
  isResyncingData: boolean = false;
  loadedIsBalanceTransfer = false;
  showResyncButton: boolean = false;
  estArrivalDate: Date;
  currentPBInvestorNonAlcStatus: boolean = false;
  isFutureTransaction: boolean = true;
  isMarkingReviewed: boolean = false;
  selectedUnderReview: any;
  reviewComment: any;
  listOfUnderReviewReasons: any;
  reviewReason: any;
  hideAddNewCustomerOption: boolean = false;
  siteInvestorDetail: any
  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private currency: CurrencyPipe
  ) {
    _fS.investmentCustomerSiteForm_fb();
    _fS.investmentNewCustomerForm_fb();
    _fS.investmentInvoiceForm_fb();
    _fS.investmentForm_fb();
  }

  ngOnInit(): void {
    this.listOfYears = this.generateArrayOfYears();
    this.getGenericPopulateRecords();
    this.getAllInvestorFromQB();
    if (this.selectedData != null) {
      this.GetInvestment(
        this.selectedData.id != null
          ? this.selectedData.id
          : this.selectedData.transactionsId
      );
    } else {
      this._fS.investmentInvoiceForm.patchValue({
        scheduledDate: new Date(),
      });

      this.GetUserSites(false);
      // this.loadPrograms('');
    }
  }
  getUnderReviewReasons() {
    this._cpS.getAllInvestmentUnderReview().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfUnderReviewReasons = response.result;
        // if (!this.getInvestmentDetail?.underReviewInfo?.isMarkedAsUnderReview) {
        //   this.currentReviewReason = this.listOfUnderReviewReasons[0];
        //   this.reviewReason = this.listOfUnderReviewReasons[0]?.id;
        // }
      }
    });
  }
  currentReviewReason: any;
  underReviewReasonChange() {
    this.currentReviewReason = this.listOfUnderReviewReasons.find(
      (x: any) => x.id == this.reviewReason
    );
  }
  updateTransactionWithUnderRviewReason(isUnderReview: boolean) {
    if (isUnderReview && !this.reviewReason) {
      this._cS.displayMessage(
        'warning',
        'Please select a reason to mark as under review'
      );
    } else {
      this.isMarkingReviewed = true;
      if (!isUnderReview) {
        // this.reviewReason = this.getInvestmentDetail.underReviewInfo.id;
        this.currentReviewReason = this.getInvestmentDetail.underReviewInfo;
      }

      var requestBody = {
        id: this.selectedData.id,
        transactionType: 1,
        underReviewId: this.currentReviewReason.id,
        reason: this.currentReviewReason.reason,
        color: this.currentReviewReason.color,
        isMarkedAsUnderReview: isUnderReview,
        emailCopy: this.currentReviewReason.emailCopy,
      };
      this._cpS
        .updateTransactionUnderReview(requestBody)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this._cS.displayMessage('success', response.message);
            this.isMarkingReviewed = false;
            // this.isVisibleInvestmentModal = false;
            this.isConfirmUnderReviewVisible = false;
            this.getInvestmentDetail.underReviewInfo = {
              id: this.currentReviewReason.id,
              reason: this.currentReviewReason.reason,
              color: this.currentReviewReason.color,
              isMarkedAsUnderReview: isUnderReview,
              emailCopy: this.currentReviewReason.emailCopy,
            };
            this.reviewReason = '';
            // this.hideInvestmentDrawer.emit({
            //   hide: this.isVisibleInvestmentModal,
            //   data: response.result,
            // });
            this._cS.underReviewCountInvestment.next('call');
          } else {
            this._cS.displayMessage('error', response.message);
            this.isMarkingReviewed = false;
          }
        });
    }
  }

  //cancel update Agency
  handleCancel(data: any) {
    this.isVisibleInvestmentModal = false;
    this.hideInvestmentDrawer.emit({
      hide: this.isVisibleInvestmentModal,
      data: data,
    });
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear();
    var min = max + 9;
    var years = [];

    for (var i = max; i <= min; i++) {
      years.push(String(i));
    }

    return years;
  }
  changeisExistingParentCompanyBehaviour() {
    this._fS.investmentNewCustomerForm.patchValue({
      parentCompanyExisting: '',
      parentCompanyNew: '',
      newParentCompanyName: '',
    });

    if (this.isExistingParentCompany == true) {
      for (const key in this._fS.investmentNewCustomerForm.controls) {
        if (
          !(
            key == 'firstName' ||
            key == 'lastName' ||
            key == 'emailAddress' ||
            key == 'mobileNumber' ||
            key == 'netTerms'
          )
        ) {
          this._fS.investmentNewCustomerForm.get(key).clearValidators();
          this._fS.investmentNewCustomerForm
            .get(key)
            .updateValueAndValidity({ onlySelf: true });
        }
      }
      this._fS.investmentNewCustomerForm
        .get('parentCompanyExisting')
        .addValidators(Validators.required);
      this._fS.investmentNewCustomerForm
        .get('parentCompanyExisting')
        .updateValueAndValidity({ onlySelf: true });

      if (this.getInvestmentDetail?.isSupplierInvestment) {
        let supplier = this.getAllSuppliers?.find(
          (supplier: any) => supplier._id == this.getInvestmentDetail?.customerDetails?.payBevCustomerDetails?.parentRefId
        );

        if (supplier) {
          this.isExistingParentCompany = true;

          this._fS.investmentNewCustomerForm.patchValue({
            parentCompanyExisting: supplier._id,
            // isExistingParentCompany: true,
          });
          this._fS.investmentNewCustomerForm.get('parentCompanyExisting').disable();

        }
      }
    } else {
      for (const key in this._fS.investmentNewCustomerForm.controls) {
        if (
          key == 'address1' ||
          key == 'city' ||
          key == 'state' ||
          key == 'zipcode' ||
          key == 'country' ||
          key == 'parentCompanyNew'
        ) {
          this._fS.investmentNewCustomerForm
            .get(key)
            .addValidators(Validators.required);
          this._fS.investmentNewCustomerForm
            .get(key)
            .updateValueAndValidity({ onlySelf: true });
        }
      }
      this._fS.investmentNewCustomerForm.patchValue({
        newParentCompanyName:
          this._fS.investmentCustomerSiteForm.value.companyName,
      });
      if (this.getInvestmentDetail.retailProgramInvestmentId) {
        this._fS.investmentNewCustomerForm.patchValue({
          parentCompanyNew: this._fS.investmentCustomerSiteForm.value.companyName,
        });
      }
      this._fS.investmentNewCustomerForm
        .get('parentCompanyExisting')
        .clearValidators();
      this._fS.investmentNewCustomerForm
        .get('parentCompanyExisting')
        .updateValueAndValidity({ onlySelf: true });
    }
  }

  getGenericPopulateRecords() {
    // type:any ,searchFilter?:any ,startPosition?:any ,pageSize?:any ,sortOrder?:any
    this._cpS.getGenericPopulateRecords('1').subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfCategory = response.result.category;
          this.listOfProductService = response.result.service;
          this.listOfTransactionClass = response.result.class;
          this.listOfTerms = response.result.term;
          let defaultTerms = this.listOfTerms.find(
            (x: any) => x.name == 'Due on receipt'
          );
          if (defaultTerms) {
            this._fS.investmentNewCustomerForm.patchValue({
              netTerms: defaultTerms.id,
            });
          }
        }
      },
      (error: any) => {
        // this._cS.displayMessage('error', error.message);
      }
    );
  }
  addLinesQBOSide() {
    this.LineStreetAddress = true
  }

  addLines(event) {
    this.LineStreetAddress = event;
    if (this.LineStreetAddress) {
      const form = this._fS.investmentCustomerSiteForm.value;
      const address =
        (form.address1?.trim() ? form.address1.trim() + '\n' : '') +
        (form.address2?.trim() ? form.address2.trim() + '\n' : '') +
        (form.city?.trim() ? form.city.trim() + ', ' : '') +
        (form.state?.trim() ? form.state.trim() + ' ' : '') +
        (form.zipcode?.trim() ? form.zipcode.trim() + '\n' : '') +
        (form.address1?.trim() ||
          form.address2?.trim() ||
          form.city?.trim() ||
          form.state?.trim() ||
          form.zipcode?.trim()
          ? form.country
          : '');

      this._fS.investmentCustomerSiteForm.patchValue({
        address1: address,
        address2: "",
        city: "",
        state: "",
        zipcode: "",
        country: "",
      });
      if (address.trim() == '' && this.investmentCustomerDetail?.isAddLine) {
        this._fS.investmentCustomerSiteForm.patchValue({
          address1: this.investmentCustomerDetail.streetAddress1,
        });
      }

      //clear validaors for address2, city, state, zipcode
      this._fS.investmentCustomerSiteForm.get('address2').clearValidators();
      this._fS.investmentCustomerSiteForm.get('city').clearValidators();
      this._fS.investmentCustomerSiteForm.get('state').clearValidators();
      this._fS.investmentCustomerSiteForm.get('zipcode').clearValidators();
      this._fS.investmentCustomerSiteForm.get('country').clearValidators();
      this._fS.investmentCustomerSiteForm
        .get('address2')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('city')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('state')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('zipcode')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('country')
        .updateValueAndValidity({ onlySelf: true });


    } else {
      if (this.investmentCustomerDetail && !this.investmentCustomerDetail.isAddLine) {
        this._fS.investmentCustomerSiteForm.patchValue({
          address1: this.investmentCustomerDetail.streetAddress1,
          address2: this.investmentCustomerDetail.streetAddress2,
          city: this.investmentCustomerDetail.city,
          state: this.investmentCustomerDetail.state,
          zipcode: this.investmentCustomerDetail.zipCode,
          country: this.investmentCustomerDetail.country,
        });
      } else {
        this._fS.investmentCustomerSiteForm.patchValue({
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipcode: '',
          country: '',
        });
      }

      //add validaors for address2, city, state, zipcode
      this._fS.investmentCustomerSiteForm
        .get('address2')
        .addValidators(Validators.required);
      this._fS.investmentCustomerSiteForm
        .get('city')
        .addValidators(Validators.required);
      this._fS.investmentCustomerSiteForm
        .get('state')
        .addValidators(Validators.required);
      this._fS.investmentCustomerSiteForm
        .get('zipcode')
        .addValidators(Validators.required);
      this._fS.investmentCustomerSiteForm
        .get('country')
        .addValidators(Validators.required);
      this._fS.investmentCustomerSiteForm
        .get('address2')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('city')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('state')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('zipcode')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.investmentCustomerSiteForm
        .get('country')
        .updateValueAndValidity({ onlySelf: true });
    }
  }

  GetInvestment(id: any) {
    this.isInvestmentSkeleton = true;
    this._cpS.GetInvestment(id).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getInvestmentDetail = response.result;
        if (this.getInvestmentDetail?.underReviewInfo?.isMarkedAsUnderReview) {
          this.currentReviewReason = this.getInvestmentDetail?.underReviewInfo;
          // this.reviewReason = this.getInvestmentDetail?.underReviewInfo?.id;
        }
        this.getUnderReviewReasons();

        if (this.getInvestmentDetail?.isSupplierInvestment) {
          this.GetUserSites(true);

          if (!this.getInvestmentDetail?.customerDetails?.quickBookCustomerDetails?.id) {
            this.getSupplierDetails();
          }
        } else {
          this.GetUserSites(false);
        }

        // this.underReviewReasonChange();
        this.showResyncButton = true;
        this.investmentCustomerDetail =
          this.getInvestmentDetail.customerDetails.payBevCustomerDetails;
        this.investmentCustomerDetailId =
          this.getInvestmentDetail.customerDetails.payBevCustomerDetails?.id;
        this.investmentquickBookDetailId =
          this.getInvestmentDetail.customerDetails.quickBookCustomerDetails?.id;
        this.investmentquickBookDetail =
          this.getInvestmentDetail.customerDetails.quickBookCustomerDetails;
        this.siteIdByPartner = this.getInvestmentDetail?.siteId;
        this._fS.investmentCustomerSiteForm.patchValue({
          partners: this.investmentCustomerDetailId,
          site: this.getInvestmentDetail?.siteId,
          companyName: this.investmentCustomerDetail.companyName,
          firstName: this.investmentCustomerDetail.name?.split(' ')[0],
          lastName: this.investmentCustomerDetail.name?.split(' ')[1],
          // representativeName: this.investmentCustomerDetail.name,
          address1: this.investmentCustomerDetail.streetAddress1,
          address2: this.investmentCustomerDetail.streetAddress2,
          city: this.investmentCustomerDetail.city,
          state: this.investmentCustomerDetail.state,
          zipcode: this.investmentCustomerDetail.zipCode,
          country: this.investmentCustomerDetail.country,
          emailAddress: this.investmentCustomerDetail.email,
          phoneNumber: this.investmentCustomerDetail.phoneNumber,
          // mobileNumber: this.investmentCustomerDetail.mobileNumber,
          mobileNumber: this.investmentCustomerDetail.phoneNumber
        });
        this.siteId = this.getInvestmentDetail?.siteId;
        this.getInvestmentDetail.createdOn = this._cS.getLocalDate(
          this.getInvestmentDetail.createdOn
        );
        this.getInvestmentDetail.scheduleDate = moment
          .utc(this.getInvestmentDetail.scheduleDate)
          .toDate();
        this.isFutureTransaction =
          new Date(
            this.getInvestmentDetail.scheduleDate?.toString().slice(0, -1)
          ).getTime() > new Date().getTime();

        if (this.getInvestmentDetail.brooklynInvestmentStatus != 1) {
          this.getInvestorDetailsBYQBOId(
            this.investmentquickBookDetail.parentRefId
          );
        }
        this.GetSiteNonAlcBalances();
        this.LineStreetAddress = this.investmentCustomerDetail.isAddLine;
        if (this.LineStreetAddress) {
          this.addLines(true);
        }
        this.loadPrograms(this.getInvestmentDetail?.siteId);

        // this.getInvestorBySiteId(this.getInvestmentDetail?.siteId)
        this.getInvestorBySiteId('');
        if (
          this.getInvestmentDetail.investmentDetails.paybevInvestment.class !=
          null
        ) {
          this._fS.investmentInvoiceForm.patchValue({
            product:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .productServices.id,
            class:
              this.getInvestmentDetail.investmentDetails.paybevInvestment.class
                .id,
            scheduledDate: this.getInvestmentDetail.scheduleDate,
            description:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .description,
            memo: this.getInvestmentDetail.investmentDetails.paybevInvestment
              .memo,
            processFee:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .processingFee,
            amount:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .amount,
            feePercent:
              this.getInvestmentDetail.investmentDetails.paybevInvestment.fee,
            isEstimate:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .isEstimate,
          });

          if (this.getInvestmentDetail.investmentDetails.paybevInvestment.class != null) {

            this.formatAmount(
              this.getInvestmentDetail.investmentDetails.paybevInvestment.amount, true
            );
            this.formatServicefee(
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .processingFee, true
            );
          }

          if (
            this.getInvestmentDetail.brooklynInvestmentStatus ==
            BrooklynInvestmentStatus.PendingApproval
          ) {
            this.formatAmount(
              this.getInvestmentDetail.investmentDetails.paybevInvestment.amount, true
            );
            this.formatServicefee(
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .processingFee, true
            );
          } else {
            this.formatAmount(
              this.getInvestmentDetail.investmentDetails.quickBookInvestment
                .amount, false
            );
            this.formatServicefee(
              this.getInvestmentDetail.investmentDetails.quickBookInvestment
                .processingFee, false
            );
          }
        } else {
          this._fS.investmentInvoiceForm.patchValue({
            scheduledDate: this.getInvestmentDetail.scheduleDate,
          });
        }
        this.calculateNetAmount();
        if (
          !this.getInvestmentDetail?.estimatedArrivalDate?.includes('0001') &&
          this.getInvestmentDetail?.estimatedArrivalDate
        ) {
          this.getInvestmentDetail.estimatedArrivalDate = moment
            .utc(this.getInvestmentDetail?.estimatedArrivalDate)
            .toDate();
          this._fS.investmentForm.patchValue({
            arrivalDate: this.getInvestmentDetail?.estimatedArrivalDate
              ?.toString()
              .includes('0001')
              ? ''
              : this.getInvestmentDetail?.estimatedArrivalDate,
          });
        }
        this.loadedIsBalanceTransfer =
          this.getInvestmentDetail?.isBalanceTransfer === true;
        this._fS.investmentForm.patchValue({
          isNonAlc: this.getInvestmentDetail?.isNonALC,
          programPeriod: this.getInvestmentDetail?.program?.id,
          isBalanceTransfer: this.loadedIsBalanceTransfer,
        });

        if (
          this.getInvestmentDetail.investmentDetails.quickBookInvestment
            ?.qboEntityDueDate &&
          this.getInvestmentDetail.investmentType == 2 &&
          !this._fS.investmentForm.value.arrivalDate
        ) {
          this._fS.investmentForm.patchValue({
            arrivalDate:
              this.getInvestmentDetail.investmentDetails.quickBookInvestment
                ?.qboEntityDueDate,
          });
        }
        if (
          this.getInvestmentDetail?.investmentDetails?.quickBookInvestment
            ?.paymentId != null
        ) {
          this.paymentArray =
            this.getInvestmentDetail?.investmentDetails?.quickBookInvestment?.paymentId?.split(
              ','
            );
        }
        if (
          this.getInvestmentDetail?.customerDetails?.quickBookCustomerDetails
            ?.qboCustomerId != null
        ) {
          for (const key in this._fS.investmentCustomerSiteForm.controls) {
            this._fS.investmentCustomerSiteForm.get(key).clearValidators();
            this._fS.investmentCustomerSiteForm
              .get(key)
              .updateValueAndValidity();
          }
        }
        // this.feePercentValueCal();
        // this.calculateFeePercentage();
        this.isInvestmentSkeleton = false;
      }
    });
  }

  getSupplierDetails() {
    this._cpS.GetInvestorDetail(this.getInvestmentDetail?.customerDetails?.payBevCustomerDetails?.parentRefId, true).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success && response.result) {
        this.siteInvestorDetail = response.result
        if (!response.result.isActive && response.result.qboEntityId) {
          this.hideAddNewCustomerOption = true;
        } else {
          this.hideAddNewCustomerOption = false;
        }
      }
    });
  }
  resynInvestmentData() {
    this.isResyncingData = true;
    this._cpS.resyncInvestmentData(this.selectedData.id).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isInvestmentDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this._cS.displayMessage('success', response.message);
            this.getInvestmentDetail = response.result;

            this.isResyncingData = false;
            this._fS.investmentForm.patchValue({
              arrivalDate: this.getInvestmentDetail?.estimatedArrivalDate
                ?.toString()
                .includes('0001')
                ? ''
                : this.getInvestmentDetail?.estimatedArrivalDate,
              isNonAlc: this.getInvestmentDetail?.isNonALC,
              programPeriod: this.getInvestmentDetail?.program.id,
            });

            if (
              this.getInvestmentDetail.investmentDetails.quickBookInvestment
                ?.qboEntityDueDate &&
              this.getInvestmentDetail.investmentType == 2 &&
              !this._fS.investmentForm.value.arrivalDate
            ) {
              this._fS.investmentForm.patchValue({
                arrivalDate:
                  this.getInvestmentDetail.investmentDetails.quickBookInvestment
                    ?.qboEntityDueDate,
              });
            }
          }
        } else {
          this._cS.displayMessage('error', response.message);
          this.isResyncingData = false;
        }
      },
      (error: any) => {
        this._cS.displayMessage('error', error.message);
        this.isResyncingData = false;
      }
    );
  }

  getInvestorBySiteId(SiteId: any) {
    this.isLoadingReps = true
    this._cpS.GetRepsName().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getAllCustomer = response.result;
        // if (this.getInvestmentDetail?.isSupplierInvestment) {
        //   const companyName = this.getInvestmentDetail?.customerDetails?.payBevCustomerDetails?.companyName || '';
        //   this.getAllCustomer = this.getAllCustomer?.filter((supplier: any) => {
        //     const normalize = (str: string) =>
        //       str?.toLowerCase().replace(/[^a-z0-9]/gi, ''); // removes punctuation/spaces
        //     return normalize(supplier.repName).includes(normalize(companyName));
        //   });
        // }
      }
      this.isLoadingReps = false;
    });
  }
  searchText: string = '';
  timer: any;

  //search supplier
  searchInvestor(event: any) {
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      this.isLoadingPartner = true;
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.getInvestorPaybevBySiteId();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.getInvestorPaybevBySiteId();
        }
      }
    }
  }

  getInvestorPaybevBySiteId() {
    setTimeout(() => {
      if (this.siteIdByPartner != '') {
        this.isLoadingPartner = true;

        this._cpS
          .GetInvestorBySite(this.siteIdByPartner, this.searchText)
          .subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.getAllSiteSelectedCustomer = response.result;
              this.isLoadingPartner = false;
              if (this.partnerId) {
                this.partnerId = '';
                this._fS.investmentCustomerSiteForm.patchValue({
                  partners: '',
                });
              }
            }
          });
        if (this.selectedData == null) {
          this._cpS
            .GetSiteDetails(this.siteIdByPartner)
            .subscribe((response: any) => {
              if (response.responseStatus == ResponseStatus.success) {
                this.getSiteDetails = response.result;
                this._fS.investmentInvoiceForm.patchValue({
                  product: this.getSiteDetails?.productServices,
                  class: this.getSiteDetails?.class,
                  feePercent: this.getSiteDetails?.processfee,
                });

                this.feePercentValueCal();
              }
            });
        }
        this.loadPrograms(this.siteIdByPartner);
      }
    }, 250);
  }

  GetInvestorDetailbypatnerID() {
    setTimeout(() => {
      if (this.partnerId != '') {
        this._cpS
          .GetInvestorDetail(this.partnerId, false)
          .subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.partnerInvestmentDetail = response.result;
              this.focusCompany('event');
              this._fS.investmentCustomerSiteForm.patchValue({
                companyName: this.partnerInvestmentDetail?.companyName,
                representativeName:
                  this.partnerInvestmentDetail?.investorDisplayName,
                firstName:
                  this.partnerInvestmentDetail?.investorDisplayName.split(
                    ' '
                  )[0],
                lastName:
                  this.partnerInvestmentDetail?.investorDisplayName.split(
                    ' '
                  )[1],
                address1: this.partnerInvestmentDetail?.streetAddress1,
                address2: this.partnerInvestmentDetail?.streetAddress2,
                city: this.partnerInvestmentDetail?.city,
                state: this.partnerInvestmentDetail?.state,
                zipcode: this.partnerInvestmentDetail?.zipCode,
                country: this.partnerInvestmentDetail?.country
                  ? this.partnerInvestmentDetail?.country
                  : '',
                // USA
                emailAddress: this.partnerInvestmentDetail?.email,
                phoneNumber: this.partnerInvestmentDetail?.phoneNumber,
                mobileNumber: this.partnerInvestmentDetail?.mobileNumber,
              });

              this._fS.investmentInvoiceForm.patchValue({
                isEstimate: !this.partnerInvestmentDetail?.isInvoice,
                feePercent:
                  this.getSiteDetails.nonAlcStatus &&
                    this.partnerInvestmentDetail?.isNonAlc
                    ? this.getSiteDetails?.nonAlcFee
                    : this.getSiteDetails?.processfee,
              });
              this._fS.investmentForm.patchValue({
                isNonAlc:
                  this.getSiteDetails.nonAlcStatus &&
                    this.partnerInvestmentDetail?.isNonAlc
                    ? true
                    : false,
              });

              let netTerms;
              if (this.partnerInvestmentDetail?.terms?.name?.includes('+')) {
                netTerms =
                  this.partnerInvestmentDetail?.terms?.name?.split('+')[1];
              }

              netTerms = Number(
                this.partnerInvestmentDetail?.terms?.name?.split(' ')[1]
              );

              if (this.selectedData == null && !isNaN(netTerms)) {
                this.estArrivalDate = new Date();
                if (this.partnerInvestmentDetail?.isInvoice) {
                  this.estArrivalDate.setDate(
                    this.estArrivalDate.getDate() + netTerms
                  );
                } else {
                  this.estArrivalDate.setDate(
                    this.estArrivalDate.getDate() + netTerms + 14
                  );
                }
                this._fS.investmentForm.patchValue({
                  arrivalDate: this.estArrivalDate,
                });
              }
              this.LineStreetAddress = this.partnerInvestmentDetail?.isAddLine;
              if (this.partnerInvestmentDetail?.qboEntityId != null) {
                for (const key in this._fS.investmentCustomerSiteForm
                  .controls) {
                  if (!(key == 'site' || key == 'partners')) {
                    this._fS.investmentCustomerSiteForm
                      .get(key)
                      .clearValidators();
                    this._fS.investmentCustomerSiteForm
                      .get(key)
                      .updateValueAndValidity();
                  }
                }
              }
            }
          });
      }
    }, 100);
  }

  //get paybev investor details
  getInvestorDetailsBYQBOId(investorQBOId) {
    this._cpS
      .GetInvestorDetailBYQBOID(investorQBOId, this.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          let investorNonAlcStatus = response.result.invertor.isNonAlc;
          let siteNonAlcStatus = response.result.site.nonAlcStatus;
          this.currentPBInvestorNonAlcStatus =
            investorNonAlcStatus && siteNonAlcStatus;
        }
      });
  }

  getAllInvestorFromQB() {
    if (this.selectedData != null) {
      this._cpS.GetInvestorBySite('', this.searchText).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.allInvestorFromQB = response.result;
        }
      });
    }
  }

  GetUserSites(isSupplierInvestment: boolean) {
    this.isLoadingSites = true;
    this._cpS.GetUserSites(isSupplierInvestment).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isLoadingSites = false;
        this.listOfUsersSites = response.result;
      }
    });
  }

  radioButtonChange() {
    var investmentCustomerSiteFormValue =
      this._fS.investmentCustomerSiteForm.value;
    if (this.radioValue == 'B') {
      this._fS.investmentNewCustomerForm.patchValue({
        firstName: investmentCustomerSiteFormValue.firstName,
        lastName: investmentCustomerSiteFormValue.lastName,
        emailAddress: investmentCustomerSiteFormValue.emailAddress,
        mobileNumber: investmentCustomerSiteFormValue.phoneNumber,
        address1: investmentCustomerSiteFormValue.address1,
        address2: investmentCustomerSiteFormValue.address2,
        country: investmentCustomerSiteFormValue.country,
        state: investmentCustomerSiteFormValue.state,
        city: investmentCustomerSiteFormValue.city,
        zipcode: investmentCustomerSiteFormValue.zipcode,
        // newParentCompanyName: investmentCustomerSiteFormValue.companyName,
      });

      this.GetSuppliersList();
    }
  }

  addNewCustomer(customerBody: any) {
    this.loadingNewCustomer = true;

    this._cpS.AddNewCustomer(customerBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          for (const key in this._fS.investmentCustomerSiteForm.controls) {
            this._fS.investmentCustomerSiteForm.get(key).clearValidators();
            this._fS.investmentCustomerSiteForm
              .get(key)
              .updateValueAndValidity();
          }
          this.getInvestmentDetail = response.result;
          this._fS.investmentForm.patchValue({
            isNonAlc: customerBody.isNonALC,
          });
          this.loadingNewCustomer = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.loadingNewCustomer = false;
        }
      },
      (error: any) => {
        // this._cS.displayMessage('error', error.message);
        this.loadingNewCustomer = false;
      }
    );
  }

  saveCustomer() {
    if (this._fS.investmentNewCustomerForm.value.isExistingParentCompany) {
      for (const key in this._fS.investmentNewCustomerForm.controls) {
        if (
          !(
            key == 'parentCompanyExisting' ||
            key == 'firstName' ||
            key == 'lastName' ||
            key == 'emailAddress' ||
            key == 'mobileNumber' ||
            key == 'netTerms'
          )
        ) {
          this._fS.investmentNewCustomerForm.get(key).clearValidators();
          this._fS.investmentNewCustomerForm.get(key).updateValueAndValidity();
        }
      }
    } else {
      if (this.LineStreetAddress) {
        //remove validators from city, state, zip and country
        this._fS.investmentNewCustomerForm.get('city').clearValidators();
        this._fS.investmentNewCustomerForm.get('state').clearValidators();
        this._fS.investmentNewCustomerForm.get('zipcode').clearValidators();
        this._fS.investmentNewCustomerForm.get('country').clearValidators();
        this._fS.investmentNewCustomerForm.get('city').updateValueAndValidity();
        this._fS.investmentNewCustomerForm.get('state').updateValueAndValidity();
        this._fS.investmentNewCustomerForm.get('zipcode').updateValueAndValidity();
        this._fS.investmentNewCustomerForm.get('country').updateValueAndValidity();
      }
    }
    if (this._fS.investmentNewCustomerForm.valid) {
      this._fS.investmentNewCustomerForm
        .get('parentCompanyExisting')
        .enable();
      const formValue = this._fS.investmentNewCustomerForm.value;
      var customerBody: any = {
        investmentId: this.selectedData.id,
        firstName: formValue.firstName.trim(),
        lastName: formValue.lastName.trim(),
        repName: formValue.firstName.trim() + ' ' + formValue.lastName.trim(),
        email: formValue.emailAddress,
        mobile: formValue.mobileNumber,
        isExistingParentCompany: formValue.isExistingParentCompany,
        companyName: '',
        companyId: '',
        termsId: formValue.netTerms,
      };
      if (formValue.isExistingParentCompany) {
        //enable parent company field
        this._fS.investmentNewCustomerForm.get('parentCompanyExisting').enable();

        var ExtingObj = this.getAllSuppliers.find(
          (ele: any) => ele._id == formValue.parentCompanyExisting
        );
        customerBody['companyName'] = ExtingObj.CompanyName;
        customerBody['companyId'] = ExtingObj.QBOEntityId;
        customerBody['address1'] = ExtingObj.StreetAddress1;
        customerBody['address2'] = ExtingObj.StreetAddress2;
        customerBody['city'] = ExtingObj.City;
        customerBody['countrySubDivisionCode'] = ExtingObj.State;
        customerBody['postalCode'] = ExtingObj.ZIPCode;
        customerBody['country'] = ExtingObj.Country;
        customerBody['isNonALC'] = ExtingObj.IsNonAlc;
      } else {
        customerBody['repName'] = formValue.parentCompanyNew;
        customerBody['companyName'] = formValue.newParentCompanyName;
        customerBody['arEmail'] = formValue.arEmailAddress;

        customerBody['address1'] = formValue.address1;
        customerBody['address2'] = formValue.address2;
        customerBody['city'] = formValue.city;
        customerBody['countrySubDivisionCode'] = formValue.state;
        customerBody['postalCode'] = formValue.zipcode;
        customerBody['country'] = formValue.country;
        customerBody['isNonALC'] = false;
      }
      this.addNewCustomer(customerBody);
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentCustomerSiteForm);
      this._cS.markFormGroupTouched(this._fS.investmentNewCustomerForm);
    }
  }

  GetSuppliersList() {
    this._cpS.GetSuppliersList().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getAllSuppliers = response.result;

        if (this.getInvestmentDetail?.isSupplierInvestment) {
          let supplier: any
          supplier = this.getAllSuppliers?.find(
            (supplier: any) => supplier._id == this.getInvestmentDetail?.customerDetails?.payBevCustomerDetails?.parentRefId
          );
          if (!supplier) {
            supplier = this.getAllSuppliers?.find(
              (supplier: any) => supplier.QBOEntityId == this.siteInvestorDetail.qboEntityId
            );
          }

          if (supplier) {
            this.isExistingParentCompany = true;

            this._fS.investmentNewCustomerForm.patchValue({
              parentCompanyExisting: supplier._id,
              // isExistingParentCompany: true,
            });
            this._fS.investmentNewCustomerForm.get('parentCompanyExisting').disable();

          }
        }
      }
    });
  }

  getInvestorDetails() {
    if (this.investmentquickBookDetailId != '') {
      this._cpS
        .GetInvestorDetailQBO(this.investmentquickBookDetailId)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.investmentquickBookDetail = response.result;
          }
        });
    }
  }

  MapCustomerInQBO() {
    this.isLoadingOne = true;
    const formData = new FormData();
    formData.set('InvestmentId', this.selectedData.id);
    formData.set('CustomerId', this.investmentquickBookDetailId);
    this._cpS.MapWithExistingCustomer(formData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.getInvestmentDetail = response.result;

        for (const key in this._fS.investmentCustomerSiteForm.controls) {
          this._fS.investmentCustomerSiteForm.get(key).clearValidators();
          this._fS.investmentCustomerSiteForm.get(key).updateValueAndValidity();
        }
        this._cS.displayMessage('success', response.message);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
  markInvestmentAsReviewed() {
    this.isMarkingReviewed = true;
    this._cpS
      .markAsReviewed(this.getInvestmentDetail?.id)
      .subscribe((response: any) => {
        this.isMarkingReviewed = false;
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          // this.handleCancel(response.result);
          this.getInvestmentDetail = response.result;
        }
      });
  }
  parentCompanyChanged(event: any) {
    let supplier = this.getAllSuppliers?.find(
      (supplier: any) => supplier._id == event
    );
    let defaultTerms = this.listOfTerms?.find(
      (x: any) => x.name == 'Due on receipt'
    );
    // if (defaultTerms) {
    //   this._fS.investmentNewCustomerForm.patchValue({
    //     netTerms: defaultTerms.id,
    //   });
    // }
    this._fS.investmentNewCustomerForm.patchValue({
      netTerms: supplier?.Terms?._id || defaultTerms?.id,
    });
  }
  markInvestmentUnderReview() {
    this.isConfirmUnderReviewVisible = true;
  }
  approveInvestment(brooklynInvestmentStatus: any) {
    var FormValueCustomerForm = this._fS.investmentCustomerSiteForm.value;
    var FormValueInvestmentForm = this._fS.investmentInvoiceForm.value;
    var FormInvestment = this._fS.investmentForm.value;
    if (
      this._fS.investmentForm.valid &&
      this._fS.investmentInvoiceForm.valid &&
      this._fS.investmentCustomerSiteForm.valid
    ) {
      this.isTransactionProcessing = true;
      this.isloadingApproveInvest = true;
      var FormValueCustomerForm = this._fS.investmentCustomerSiteForm.value;
      var FormValueInvestmentForm = this._fS.investmentInvoiceForm.value;
      var FormInvestment = this._fS.investmentForm.value;
      var investmentbody = {
        id: this.getInvestmentDetail?.id,
        investmentType: FormValueInvestmentForm.isEstimate ? 1 : 2,
        companyName: this.getInvestmentDetail?.companyName,
        repName: this.getInvestmentDetail?.repName,
        repId: this.getInvestmentDetail?.repId,
        productServices: this.getInvestmentDetail?.productServices,
        class: this.getInvestmentDetail?.class,
        program: this.getInvestmentDetail?.program,
        description: FormValueInvestmentForm.description,
        qboEntityId: this.getInvestmentDetail?.qboEntityId,
        qboEntityNo: this.getInvestmentDetail?.qboEntityNo,
        scheduleDate: this.getInvestmentDetail?.scheduleDate,
        qboEntityDueDate: this.getInvestmentDetail?.qboEntityDueDate,
        brooklynInvestmentStatus: brooklynInvestmentStatus,
        paybevInvestmentStatus:
          this.getInvestmentDetail?.paybevInvestmentStatus,
        isPaybevConfirmed: this.getInvestmentDetail?.isPaybevConfirmed,
        estimatedArrivalDate: FormInvestment.arrivalDate,
        isNonALC: FormInvestment.isNonAlc,
        isBalanceTransfer: !!FormInvestment.isBalanceTransfer,
        siteId: this.getInvestmentDetail?.siteId,
        siteName: this.getInvestmentDetail?.siteName,
        processfee: this._fS.investmentInvoiceForm.value.feePercent,
        amount: this.currentInvoiceAmount,
        processingFee: this.currentInvoiceProcessFee,
        stage: this.getInvestmentDetail?.stage,
        customerDetails: {
          isMapWithExisting:
            this.getInvestmentDetail?.customerDetails.isMapWithExisting,
          payBevCustomerDetails: {
            id: this.investmentCustomerDetail.id,
            qboCustomerId: this.investmentCustomerDetail.qboCustomerId,
            qboCustomerNo: this.investmentCustomerDetail.qboCustomerNo,
            name:
              FormValueCustomerForm.firstName +
              ' ' +
              FormValueCustomerForm.lastName,
            companyName: FormValueCustomerForm.companyName,
            streetAddress1: FormValueCustomerForm.address1,
            streetAddress2: FormValueCustomerForm.address2,
            isAddLine: this.LineStreetAddress,
            city: FormValueCustomerForm.city,
            state: FormValueCustomerForm.state,
            zipCode: FormValueCustomerForm.zipcode,
            country: FormValueCustomerForm.country,
            parentRefId: this.investmentCustomerDetail?.parentRefId,
            email: FormValueCustomerForm.emailAddress,
            phoneNumber: FormValueCustomerForm.phoneNumber,
            mobileNumber: FormValueCustomerForm.mobileNumber,
            terms: this.investmentCustomerDetail.terms,
            paymentMethod: this.investmentCustomerDetail.paymentMethod,
          },
          quickBookCustomerDetails: {
            id: this.getInvestmentDetail.customerDetails
              .quickBookCustomerDetails.id,
            qboCustomerId:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .qboCustomerId,
            qboCustomerNo:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .qboCustomerNo,
            name: this.getInvestmentDetail.customerDetails
              .quickBookCustomerDetails.name,
            companyName:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .companyName,
            streetAddress1:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .streetAddress1,
            streetAddress2:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .streetAddress2,
            city: this.getInvestmentDetail.customerDetails
              .quickBookCustomerDetails.city,
            state:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .state,
            zipCode:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .zipCode,
            country:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .country,
            parentRefId:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                ?.parentRefId,
            email:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .email,
            phoneNumber:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .phoneNumber,
            mobileNumber:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .mobileNumber,
            terms:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .terms,
            paymentMethod:
              this.getInvestmentDetail.customerDetails.quickBookCustomerDetails
                .paymentMethod,
          },
        },

        investmentDetails: {
          paybevInvestment: {
            productServices:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .productServices,
            class:
              this.getInvestmentDetail.investmentDetails.paybevInvestment.class,
            companyName:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .companyName,
            repName:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                .repName,
            repId:
              this.getInvestmentDetail.investmentDetails.paybevInvestment.repId,
            memo: FormValueInvestmentForm.memo,
            amount: this.currentInvoiceAmount,
            processingFee: this.currentInvoiceProcessFee,
            fee: FormValueInvestmentForm.feePercent,
            isEstimate: FormValueInvestmentForm.isEstimate,
            description: FormValueInvestmentForm.description,
          },
          quickBookInvestment:
            this.getInvestmentDetail?.investmentDetails.quickBookInvestment,
        },
        comment: this.getInvestmentDetail?.comment,
        createdBy: this.getInvestmentDetail?.createdBy,
        createdById: this.getInvestmentDetail?.createdById,
        createdOn: this.getInvestmentDetail?.createdOn,
        modifyBy: this.getInvestmentDetail?.modifyBy,
        modifyById: this.getInvestmentDetail?.modifyById,
        modifyOn: this.getInvestmentDetail?.modifyOn,
        isSupplierInvestment: this.getInvestmentDetail?.isSupplierInvestment,
        retailProgramInvestmentId: this.getInvestmentDetail?.retailProgramInvestmentId,
      };

      const requestedBalanceTransferFlag = !!FormInvestment.isBalanceTransfer;
      const shouldSyncBalanceTransferBeforeApprove =
        requestedBalanceTransferFlag !== this.loadedIsBalanceTransfer;

      const runApprove = () => {
        investmentbody.isBalanceTransfer = requestedBalanceTransferFlag;
        this._cpS.ApproveInvestment(investmentbody).subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            if (this.getInvestmentDetail.underReviewInfo?.isMarkedAsUnderReview) {
              this.updateTransactionWithUnderRviewReason(false);
            }
            this.loadedIsBalanceTransfer = requestedBalanceTransferFlag;
            this._cS.displayMessage('success', response.message);
            this.isTransactionProcessing = false;
            this.isVisibleInvestmentModal = false;
            this.hideInvestmentDrawer.emit({
              hide: this.isVisibleInvestmentModal,
              data: response.result,
            });
            this.getInvestmentDetail = response.result;
            this.getInvestmentDetail.brooklynInvestmentStatus =
              response.result.brooklynInvestmentStatus;
            this.getInvestmentDetail.isBalanceTransfer =
              requestedBalanceTransferFlag;
            this.isloadingApproveInvest = false;
          } else {
            this.isTransactionProcessing = false;
            this._cS.displayMessage('error', response.message);
            this.isloadingApproveInvest = false;
          }
        });
      };

      if (shouldSyncBalanceTransferBeforeApprove) {
        this._cpS
          .setInvestmentBalanceTransferFlag({
            investmentId: this.getInvestmentDetail.id,
            isBalanceTransfer: requestedBalanceTransferFlag,
          })
          .subscribe((flagResponse: any) => {
            if (flagResponse.responseStatus == ResponseStatus.success) {
              runApprove();
            } else {
              this.isTransactionProcessing = false;
              this.isloadingApproveInvest = false;
              this._cS.displayMessage('error', flagResponse.message);
            }
          });
      } else {
        runApprove();
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentInvoiceForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentCustomerSiteForm);
    }
  }
  formatAmount(amount: any, isPaybevAmount: boolean) {
    if (amount) {
      if (amount.toString().includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount.toString().replace(',', '');

      if (isPaybevAmount) {
        this.currentInvoiceAmount = Number(amount);
        this._fS.investmentInvoiceForm.patchValue({
          amount: this.currency.transform(amount),
        });
      } else {
        this.currentQuickbooksAmount = Number(amount)
      }
      // this.amountNumber = this.currency.transform(amount);
    }
  }
  formatServicefee(processFee: any, isPaybevServiceFee: boolean) {
    if (processFee != null) {
      if (processFee.toString().includes('$')) {
        processFee = processFee.split('$')[1];
      }
      processFee = processFee.toString().replace(',', '');
      if (isPaybevServiceFee) {
        this.currentInvoiceProcessFee = Number(processFee);
        this._fS.investmentInvoiceForm.patchValue({
          processFee: this.currency.transform(this.currentInvoiceProcessFee),
        });
      } else {
        this.currentQuickbooksInvoiceProcessFee = Number(processFee);
      }
    }
  }

  loadPrograms(siteId: any) {
    if (siteId) {
      this.isLoadingPrograms = true;
      this._cpS.getProgramBySite(siteId).subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.isLoadingPrograms = false;
            this.listOfProgramPeriods = response.result;
            var defaultProgram = this.listOfProgramPeriods.find(
              (x: any) => x?.isDefault
            );
            if (this.selectedData == null) {
              this._fS.investmentForm.patchValue({
                programPeriod: defaultProgram?.id,
              });
            }
          } else {
            this.listOfProgramPeriods = [];
            this.isLoadingPrograms = false;
            this._cS.displayMessage('error', response.message);
          }
        },
        (error: any) => {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
        }
      );
    }
  }

  private completeSaveInvestmentSuccess(response: any, callingName: any) {
    this.isTransactionProcessing = false;
    this._cS.displayMessage('success', response.message);
    this.isVisibleInvestmentModal = false;
    this.hideInvestmentDrawer.emit({
      hide: this.isVisibleInvestmentModal,
      data: response.result,
    });
    this.resetSaveInvestmentLoadingState(callingName);
  }

  private resetSaveInvestmentLoadingState(callingName: any) {
    callingName == 'UNDERREVIEW'
      ? (this.isloadingUnderReviewInvest = false)
      : callingName == 'UPDATE'
        ? (this.isloadingSaveInvest = false)
        : callingName == 'CANCELUNDERREVIEW'
          ? (this.isloadingUnderReviewInvest = false)
          : callingName == 'CANCEL'
            ? (this.isloadingCancelInvest = false)
            : (this.isloadingCancelInvest = false);
  }

  //UPDATE INVESTMENT
  saveInvestment(
    brooklynInvestmentStatus: any,
    paybevInvestmentStatus: any,
    callingName: any
  ) {
    const invalid = [];
    const controls = this._fS.investmentCustomerSiteForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    if (
      this.getInvestmentDetail.investmentDetails.paybevInvestment.class == null
    ) {
      for (const key in this._fS.investmentInvoiceForm.controls) {
        this._fS.investmentInvoiceForm.get(key).clearValidators();
        this._fS.investmentInvoiceForm.get(key).updateValueAndValidity();
      }
    }
    if (
      this._fS.investmentForm.valid &&
      this._fS.investmentInvoiceForm.valid &&
      this._fS.investmentCustomerSiteForm.valid
    ) {
      this.isTransactionProcessing = true;
      callingName == 'UNDERREVIEW'
        ? (this.isloadingUnderReviewInvest = true)
        : callingName == 'UPDATE'
          ? (this.isloadingSaveInvest = true)
          : callingName == 'CANCELUNDERREVIEW'
            ? (this.isloadingUnderReviewInvest = true)
            : callingName == 'CANCEL'
              ? (this.isloadingCancelInvest = true)
              : (this.isloadingCancelInvest = true);
      var FormValueCustomerForm = this._fS.investmentCustomerSiteForm.value;
      var FormValueInvestmentForm = this._fS.investmentInvoiceForm.value;
      var FormInvestment = this._fS.investmentForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == FormInvestment.programPeriod
      );

      var selectedClass = this.listOfTransactionClass.find(
        (x: any) => x.id == FormValueInvestmentForm.class
      );
      var selectedProduct = this.listOfProductService.find(
        (x: any) => x.id == FormValueInvestmentForm.product
      );
      var investmentbody = this.getInvestmentDetail;
      investmentbody = {
        id: this.getInvestmentDetail.id ? this.getInvestmentDetail.id : null,
        investmentType:
          this.getInvestmentDetail.brooklynInvestmentStatus == 1 ||
            this.getInvestmentDetail.brooklynInvestmentStatus == 2
            ? FormValueInvestmentForm.isEstimate
              ? 1
              : 2
            : this.getInvestmentDetail.investmentType,
        companyName: this.getInvestmentDetail.companyName
          ? this.getInvestmentDetail.companyName
          : null,
        repName: this.getInvestmentDetail.repName
          ? this.getInvestmentDetail.repName
          : null,
        repId: this.getInvestmentDetail.repId
          ? this.getInvestmentDetail.repId
          : null,
        productServices: {
          id: selectedProduct?.id,
          name: selectedProduct?.name,
        },
        class:
          this.getInvestmentDetail.investmentDetails.paybevInvestment.class ==
            null
            ? this.getInvestmentDetail.investmentDetails.quickBookInvestment
              .class
            : {
              id: selectedClass?.id,
              name: selectedClass?.name,
            },
        isSeen: this.getInvestmentDetail.isSeen,
        underReviewInfo: this.getInvestmentDetail.underReviewInfo,
        program: {
          id: FormInvestment?.programPeriod,
          name: selectedProgram?.label,
        },
        description: FormValueInvestmentForm.description,
        qboEntityId: this.getInvestmentDetail.qboEntityId
          ? this.getInvestmentDetail.qboEntityId
          : null,
        qboEntityNo: this.getInvestmentDetail.qboEntityNo
          ? this.getInvestmentDetail.qboEntityNo
          : null,
        scheduleDate: FormValueInvestmentForm.scheduledDate,
        qboEntityDueDate: this.getInvestmentDetail?.qboEntityDueDate,
        brooklynInvestmentStatus: brooklynInvestmentStatus,
        paybevInvestmentStatus: paybevInvestmentStatus,
        isPaybevConfirmed: this.getInvestmentDetail.isPaybevConfirmed,
        estimatedArrivalDate: FormInvestment.arrivalDate,
        isNonALC: FormInvestment.isNonAlc,
        isBalanceTransfer:
          callingName == 'UPDATE'
            ? !!FormInvestment.isBalanceTransfer
            : this.loadedIsBalanceTransfer,
        siteId: this.getInvestmentDetail.siteId,
        siteName: this.getInvestmentDetail.siteName,
        processfee: this._fS.investmentInvoiceForm.value.feePercent,
        stage: this.getInvestmentDetail.stage,
        amount:
          this.getInvestmentDetail.brooklynInvestmentStatus == BrooklynInvestmentStatus.PendingApproval ? this.currentInvoiceAmount : (this.getInvestmentDetail.investmentDetails.paybevInvestment.class ==
            null
            ? this.getInvestmentDetail.amount
            : this.currentQuickbooksAmount),
        processingFee:
          this.getInvestmentDetail.brooklynInvestmentStatus == BrooklynInvestmentStatus.PendingApproval ? this.currentInvoiceProcessFee
            : (this.getInvestmentDetail.investmentDetails.paybevInvestment.class ==
              null
              ? this.getInvestmentDetail.processingFee
              : this.currentQuickbooksInvoiceProcessFee),
        customerDetails: {
          isMapWithExisting:
            this.getInvestmentDetail.customerDetails.isMapWithExisting,
          payBevCustomerDetails: {
            id: this.investmentCustomerDetail.id,
            qboCustomerId: this.investmentCustomerDetail.qboCustomerId,
            qboCustomerNo: this.investmentCustomerDetail.qboCustomerNo,
            name:
              FormValueCustomerForm.firstName +
              ' ' +
              FormValueCustomerForm.lastName,
            companyName: FormValueCustomerForm.companyName,
            streetAddress1: FormValueCustomerForm.address1,
            streetAddress2: FormValueCustomerForm.address2,
            isAddLine: this.LineStreetAddress,
            city: FormValueCustomerForm.city,
            state: FormValueCustomerForm.state,
            zipCode: FormValueCustomerForm.zipcode,
            country: FormValueCustomerForm.country,
            parentRefId: this.investmentCustomerDetail?.parentRefId,
            email: FormValueCustomerForm.emailAddress,
            phoneNumber: FormValueCustomerForm.phoneNumber,
            mobileNumber: FormValueCustomerForm.mobileNumber,
            terms: this.investmentCustomerDetail.terms,
            paymentMethod: this.investmentCustomerDetail.paymentMethod,
          },
          quickBookCustomerDetails: {
            id: this.getInvestmentDetail.customerDetails
              ?.quickBookCustomerDetails?.id,
            qboCustomerId:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.qboCustomerId,
            qboCustomerNo:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.qboCustomerNo,
            name: this.getInvestmentDetail.customerDetails
              ?.quickBookCustomerDetails?.name,
            companyName:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.companyName,
            streetAddress1:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.streetAddress1,
            streetAddress2:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.streetAddress2,
            city: this.getInvestmentDetail.customerDetails
              ?.quickBookCustomerDetails?.city,
            state:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.state,
            zipCode:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.zipCode,
            country:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.country,
            parentRefId:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.parentRefId,
            email:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.email,
            phoneNumber:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.phoneNumber,
            mobileNumber:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.mobileNumber,
            terms:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.terms,
            paymentMethod:
              this.getInvestmentDetail.customerDetails?.quickBookCustomerDetails
                ?.paymentMethod,
          },
        },

        investmentDetails: {
          paybevInvestment: {
            productServices:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                ?.productServices,
            class:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                ?.class,
            companyName:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                ?.companyName,
            repName:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                ?.repName,
            repId:
              this.getInvestmentDetail.investmentDetails.paybevInvestment
                ?.repId,
            memo: FormValueInvestmentForm.memo,
            amount: this.currentInvoiceAmount,
            processingFee: this.currentInvoiceProcessFee,
            scheduleDate: FormValueInvestmentForm.scheduledDate,
            fee: FormValueInvestmentForm.feePercent,
            isEstimate: FormValueInvestmentForm.isEstimate,
            description: FormValueInvestmentForm.description,
          },
          quickBookInvestment:
            this.getInvestmentDetail?.investmentDetails?.quickBookInvestment,
        },
        comment: this.getInvestmentDetail.comment,
        createdBy: this.getInvestmentDetail.createdBy,
        createdById: this.getInvestmentDetail.createdById,
        createdOn: this.getInvestmentDetail.createdOn,
        ApproveOn: this.getInvestmentDetail.approveOn,
        ApproverBy: this.getInvestmentDetail.approverBy,
        ApproverId: this.getInvestmentDetail.approverId,
        modifyBy: this.getInvestmentDetail.modifyBy,
        modifyById: this.getInvestmentDetail.modifyById,
        modifyOn: this.getInvestmentDetail.modifyOn,
        isSupplierInvestment: this.getInvestmentDetail?.isSupplierInvestment,
        retailProgramInvestmentId: this.getInvestmentDetail?.retailProgramInvestmentId,
      };

      this._cpS.SaveInvestment(investmentbody).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          const requestedBalanceTransferFlag =
            callingName == 'UPDATE'
              ? !!FormInvestment.isBalanceTransfer
              : this.loadedIsBalanceTransfer;
          const shouldSyncBalanceTransferFlag =
            callingName == 'UPDATE' &&
            requestedBalanceTransferFlag !== this.loadedIsBalanceTransfer;

          if (shouldSyncBalanceTransferFlag) {
            this._cpS
              .setInvestmentBalanceTransferFlag({
                investmentId: this.getInvestmentDetail.id,
                isBalanceTransfer: requestedBalanceTransferFlag,
              })
              .subscribe((flagResponse: any) => {
                if (flagResponse.responseStatus == ResponseStatus.success) {
                  this.loadedIsBalanceTransfer = requestedBalanceTransferFlag;
                  this.getInvestmentDetail.isBalanceTransfer =
                    requestedBalanceTransferFlag;
                  this.completeSaveInvestmentSuccess(
                    response,
                    callingName
                  );
                } else {
                  this.isTransactionProcessing = false;
                  this._cS.displayMessage('error', flagResponse.message);
                  this.resetSaveInvestmentLoadingState(callingName);
                }
              });
          } else {
            this.completeSaveInvestmentSuccess(response, callingName);
          }
        } else {
          this.isTransactionProcessing = false;
          this._cS.displayMessage('error', response.message);
          this.resetSaveInvestmentLoadingState(callingName);
        }
      });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentInvoiceForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentCustomerSiteForm);
    }
  }

  //SAVE INVESTMENT
  scheduleInvestment() {
    const invalid = [];
    const controls = this._fS.investmentCustomerSiteForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    if (
      this._fS.investmentForm.valid &&
      this._fS.investmentInvoiceForm.valid &&
      this._fS.investmentCustomerSiteForm.valid &&
      this.isInvalidAmount == false
    ) {
      this.isTransactionProcessing = true;
      this.isloadingSaveInvest = true;
      var FormValueCustomerForm = this._fS.investmentCustomerSiteForm.value;
      var FormValueInvestmentForm = this._fS.investmentInvoiceForm.value;
      var FormInvestment = this._fS.investmentForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == FormInvestment.programPeriod
      );
      var selectedRep = this.getAllSiteSelectedCustomer.find(
        (x: any) => x._id == FormValueCustomerForm.partners
      );
      var selectedClass = this.listOfTransactionClass.find(
        (x: any) => x.id == FormValueInvestmentForm.class
      );
      var selectedProduct = this.listOfProductService.find(
        (x: any) => x.id == FormValueInvestmentForm.product
      );

      var investmentbody = {
        siteId: this.siteIdByPartner,
        companyName: FormValueCustomerForm.companyName,
        repName: selectedRep.InvestorDisplayName,
        repId: FormValueCustomerForm.partners,
        program: {
          id: FormInvestment.programPeriod,
          name: selectedProgram.label,
        },
        isNonALC: FormInvestment.isNonAlc,
        estimatedArrivalDate: moment(FormInvestment.arrivalDate).utc().format(),
        customerDetails: {
          id: FormValueCustomerForm.partners,
          qboCustomerId: this.partnerInvestmentDetail?.qboEntityId,
          qboCustomerNo: null,
          name:
            FormValueCustomerForm.firstName +
            ' ' +
            FormValueCustomerForm.lastName,
          companyName: FormValueCustomerForm.companyName,
          streetAddress1: FormValueCustomerForm.address1,
          streetAddress2: FormValueCustomerForm.address2,
          isAddLine: this.LineStreetAddress,
          city: FormValueCustomerForm.city,
          state: FormValueCustomerForm.state,
          zipCode: FormValueCustomerForm.zipcode,
          country: FormValueCustomerForm.country,
          parentRefId: null,
          email: FormValueCustomerForm.emailAddress,
          phoneNumber: FormValueCustomerForm.phoneNumber,
          mobileNumber: FormValueCustomerForm.mobileNumber,
          terms: null,
          paymentMethod: null,
        },
        investmentDetails: {
          productServices: {
            id: selectedProduct.id,
            name: selectedProduct.name,
          },
          class: {
            id: selectedClass.id,
            name: selectedClass.name,
          },
          companyName: null,
          repName: null,
          repId: null,
          memo: FormValueInvestmentForm.memo,
          amount: this.currentInvoiceAmount,
          processingFee: this.currentInvoiceProcessFee,
          fee: FormValueInvestmentForm.feePercent,
          isEstimate: FormValueInvestmentForm.isEstimate,
          description: FormValueInvestmentForm.description,
        },
        scheduleDate: moment(FormValueInvestmentForm.scheduledDate)
          .utc()
          .format(),
      };

      this._cpS
        .ScheduleInvestment(investmentbody)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.isTransactionProcessing = false;
            this._cS.displayMessage('success', response.message);
            //hide unit drawer
            this.isVisibleInvestmentModal = false;
            this.hideInvestmentDrawer.emit({
              hide: this.isVisibleInvestmentModal,
              data: response.result,
            });
            this.isloadingSaveInvest = false;
          } else {
            this.isTransactionProcessing = false;
            this._cS.displayMessage('error', response.message);
            this.isloadingSaveInvest = false;
          }
        });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentInvoiceForm);
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.investmentCustomerSiteForm);
      if (this._fS.investmentCustomerSiteForm.value.amount > 99999999.99) {
        this._cS.displayMessage(
          'warning',
          'Amount cannot be greater than $99,999,999.99'
        );
      }
    }
  }

  //Non_alc Listing
  GetSiteNonAlcBalances() {
    this._cpS.GetSiteNonAlcBalance(this.siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.nonalcResult = response.result;
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  deleteEstimate() {
    const formData = new FormData();
    formData.set('InvestmentId', this.selectedData.id);
    this._cpS.DeleteInvestment(formData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);
        this.isVisibleInvestmentModal = false;
        this.hideInvestmentDrawer.emit({
          hide: this.isVisibleInvestmentModal,
          data: null,
        });
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }
  calculateNetAmount() {
    if (this.getInvestmentDetail != null) {
      let siteProcessFee = String(
        this._fS.investmentInvoiceForm.value.feePercent
      );

      if (siteProcessFee?.includes('%')) {
        siteProcessFee = siteProcessFee.split('%')[0];
      }
      this.feeValueCal = +this.currentInvoiceAmount * (+siteProcessFee / 100);
      this.getInvestmentDetail.investmentDetails.paybevInvestment.amount =
        this.currentInvoiceAmount;
      this.netAmount =
        +(this.getInvestmentDetail.brooklynInvestmentStatus == 1 ||
          this.getInvestmentDetail.brooklynInvestmentStatus == 2 ||
          this.getInvestmentDetail.brooklynInvestmentStatus == 7
          ? this.getInvestmentDetail.investmentDetails.paybevInvestment.amount
          : this.getInvestmentDetail.investmentDetails.quickBookInvestment
            .amount) -
        +(this.getInvestmentDetail.brooklynInvestmentStatus == 1 ||
          this.getInvestmentDetail.brooklynInvestmentStatus == 2 ||
          this.getInvestmentDetail.brooklynInvestmentStatus == 7
          ? this.feeValueCal
          : this.getInvestmentDetail.investmentDetails.quickBookInvestment
            .processingFee);
    }
  }
  feePercentValueCal() {
    if (
      this._fS.investmentInvoiceForm.value.amount &&
      this._fS.investmentInvoiceForm.value.feePercent
    ) {
      var siteProcessFee;
      siteProcessFee = String(this._fS.investmentInvoiceForm.value.feePercent);
      if (siteProcessFee.includes('%')) {
        siteProcessFee = siteProcessFee.split('%')[0];
      }
      this.feeValueCal = +this.currentInvoiceAmount * (+siteProcessFee / 100);
      this._fS.investmentInvoiceForm.patchValue({
        processFee: this.feeValueCal,
      });
      this.formatServicefee(this._fS.investmentInvoiceForm.value.processFee, true);
      setTimeout(() => {
        this.calculateNetAmount();
        // this.getInvestmentDetail.investmentDetails.paybevInvestment.amount = parseFloat(this.getInvestmentDetail.investmentDetails.paybevInvestment.amount).toFixed(2)
      }, 200);
    }
  }
  calculateFeePercentage() {
    let feePercentage = this._fS.investmentInvoiceForm.value.feePercent;
    let amount = this._fS.investmentInvoiceForm.value.amount;
    let processFee = this._fS.investmentInvoiceForm.value.processFee;

    if (processFee.toString().includes('$')) {
      processFee = processFee.split('$')[1];
    }
    processFee = processFee.toString().replace(',', '');
    let processFeeValue = Number(processFee);

    if (this.currentInvoiceAmount > 0) {
      feePercentage = (processFeeValue / this.currentInvoiceAmount) * 100;
    } else {
      feePercentage = 0;
    }
    this._fS.investmentInvoiceForm.patchValue({
      feePercent: feePercentage,
    });
    this.calculateNetAmount();
  }
  checkMaxValue() {
    let tempLiability = this._fS.investmentInvoiceForm.get('amount').value;
    if (tempLiability.toString().includes('$')) {
      tempLiability = tempLiability.split('$')[1];
    }
    tempLiability = tempLiability.toString().replaceAll(',', '');
    if (Number(tempLiability) > 99999999.99) {
      this.isInvalidAmount = true;
      this._cS.displayMessage(
        'warning',
        'Amount cannot be greater than $99,999,999.99'
      );
    } else {
      this.isInvalidAmount = false;
    }
  }
  focusZipCode(event) {
    if (event) {
      this.zipcode.nativeElement.focus();
    }
  }
  focusCompany(event) {
    if (event) {
      if (
        this.partnerInvestmentDetail?.qboEntityId == null &&
        this.getInvestmentDetail?.customerDetails?.quickBookCustomerDetails
          ?.qboCustomerId == null
      ) {
        this.company.nativeElement.focus();
      } else {
        this.focusDesc('event');
      }
    }
  }
  focusDesc(event) {
    if (event) {
      this.desc.nativeElement.focus();
    }
  }
  focusPartnerDD(event) {
    if (event) {
      this.partnerDD?.focus();
    }
  }
  focusCity(event) {
    if (
      event &&
      this.partnerInvestmentDetail?.qboEntityId == null &&
      this.getInvestmentDetail?.customerDetails?.quickBookCustomerDetails
        ?.qboCustomerId == null
    ) {
      this.city.nativeElement.focus();
    }
  }
}
